var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "handover-takeback" }, [
    _c(
      "div",
      { staticClass: "tms-dashboard__panel-header row" },
      [
        _c(
          "div",
          { staticClass: "tms-dashboard__panel-container-without-button" },
          [
            _c("div", { staticClass: "tms-dashboard__panel-title-box" }, [
              _c("div", { staticClass: "tms-dashboard__panel-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("currentHandoverTakeback")) +
                    "\n          "
                ),
                _c("i", {
                  staticClass: "fa fa-refresh dark flat icon_refresh",
                  attrs: { id: "dashboard_refresh" },
                  on: {
                    click: function ($event) {
                      return _vm.loadHotbsWithQuery()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tms-dashboard__panel-view-all" },
                [
                  _c("router-link", { attrs: { to: "/tenant-projects" } }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("viewAll")) +
                        " >\n          "
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tms-dashboard__panel-toolbar" }, [
              _c("div", { staticClass: "handover-takeback__counter" }, [
                _c(
                  "div",
                  { staticClass: "handover-takeback__counter--handover" },
                  [
                    _c(
                      "div",
                      { staticClass: "handover-takeback__counter--number" },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.handoverCount) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "handover-takeback__counter--hint" },
                      [_vm._v(_vm._s(_vm.$t("handover.title")))]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "handover-takeback__counter--takeback" },
                  [
                    _c(
                      "span",
                      { staticClass: "handover-takeback__counter--number" },
                      [_vm._v(" " + _vm._s(_vm.takebackCount) + " ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "handover-takeback__counter--hint" },
                      [_vm._v(_vm._s(_vm.$t("takeback.title")))]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "handover-takeback__counter--duration" },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("showLabel")) + ":")]),
                  _vm._v(" "),
                  _c("HKLSelect", {
                    attrs: {
                      options: _vm.timeHklOptions,
                      placeholder: "",
                      showSearch: false,
                      value: _vm.selectedTimeValue,
                    },
                    on: { change: _vm.updateShowHandoverTakeback },
                  }),
                ],
                1
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("HKLButton", {
          staticClass: "tms-dashboard__panel-reset-btn",
          attrs: { color: "darkblue", action: "reset" },
          on: { click: _vm.resetFilter },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "handover-takeback__table" }, [
      _c("table", { staticClass: "sort_table" }, [
        _c("thead", [
          _c(
            "tr",
            { staticClass: "handover-takeback__table--header" },
            _vm._l(_vm.tableHeaders, function (header, index) {
              return _c(
                "th",
                {
                  key: index,
                  class: header.className,
                  on: {
                    click: function ($event) {
                      return _vm.sortTable(header)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    { class: header.attr === "premises" ? "placeholder" : "" },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(header.name) +
                          "\n              "
                      ),
                      _vm.sortingAttr === header.attr
                        ? _c("i", {
                            class: [
                              _vm.reverse ? "triangle-down" : "triangle-up",
                            ],
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.sortedHotbs, function (hotb) {
            return _c(
              "tr",
              { key: hotb.id, staticClass: "handover-takeback__table--body" },
              [
                _c("td", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        hotb.completedDate
                          ? _vm.dateUtil.format(hotb.completedDate, "DD MMM YY")
                          : hotb.scheduledTransactionDate
                          ? _vm.dateUtil.format(
                              hotb.scheduledTransactionDate,
                              "DD MMM YY, HH:mm"
                            )
                          : hotb.transactionDate
                          ? _vm.dateUtil.format(
                              hotb.transactionDate,
                              "DD MMM YY"
                            )
                          : _vm.emptyValue
                      ) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm._f("customTProjectTypeLabel")(
                        hotb.type || _vm.emptyValue
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(hotb.companyName || _vm.emptyValue))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(hotb.tradeName || _vm.emptyValue))]),
                _vm._v(" "),
                _c("td", [
                  _c("div", { staticClass: "pin-box" }, [
                    _c("div", { staticClass: "pin-placeholder" }, [
                      hotb.showPin
                        ? _c("div", { staticClass: "pin__bubble-orange" }, [
                            _c("i", {
                              staticClass: "fa fa-thumb-tack",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "link_text",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.navToDetail(hotb)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(hotb.premises || _vm.emptyValue) +
                            "\n              "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm._f("customStatusLabel")(hotb.status || _vm.emptyValue)
                    )
                  ),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }